'use strict';

const en = require('./en');
const es = require('./es');
module.exports = {
    en,
    es
};


// WEBPACK FOOTER //
// ./conversationTranscript/defaultLabels/index.js